<template>
  <RevInfoBlock
    :icon="IconWarning"
    :title="i18n(translations.infoTitle)"
    variant="warning"
  >
    <p class="text-static-default-mid body-2">
      {{ i18n(translations.infoContent) }}
    </p>

    <RevButton size="small" :to="coveragePaymentFailureLink" variant="primary">
      {{ i18n(translations.infoCta) }}
    </RevButton>
  </RevInfoBlock>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { PaymentFlow } from '@backmarket/nuxt-layer-payment/pages/config/flows'
import { usePaymentRouteLocation } from '@backmarket/nuxt-layer-payment/pages/navigation/usePaymentRouteLocation'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './CoveragePaymentAdvertisement.translations'
import type { CoveragePaymentAdvertisementProps } from './CoveragePaymentAdvertisement.types'

const props = defineProps<CoveragePaymentAdvertisementProps>()

const i18n = useI18n()

const getPaymentRouteLocation = usePaymentRouteLocation(
  PaymentFlow.INSURANCE_UPDATE_PAYMENT_METHOD,
)

const coveragePaymentFailureLink = computed(() =>
  getPaymentRouteLocation({ policyId: props.policyId }),
)
</script>
